// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocationDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class LocationApiClient extends BaseCRUDApiClient<LocationDto> {
  baseUrl = this.config.apiEndpoint + '/location';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
